(function (parentalleave, $) {
    parentalleave.init = function () {
        $('[name="PriorLeave"]').on("change", function () {
            let priorHoursDiv = $("#PriorHours");
            switch ($(this).val()) {
                case "True":
                    priorHoursDiv.show(500);
                    break;
                case "False":
                    priorHoursDiv.hide(500);

                    break;
            }

           
        });

        $('[name="Region"]').on("change", function () {
            $.ajax({
                url: "/ParentalLeave/Home/SetRegion",
                cache: false,
                data: {
                    parentalLeaveRequestKey: $("#Key").val(),
                    region: $(this).val()
                },
                success: function (result) {
                    if (result.success) {
                        $("#region-error").hide(500);
                        global.loadgrid(result.gridId);
                    }
                    else {
                        $("#region-error").show(500);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $("#region-error").show(500);
                }
            });
        });

        $("[data-parentalleavetype]").on("change", function () {
            const onlyPaid = 0;
            const onlyUnpaid = 1;

            let leaveType = $(this).val();

            if (leaveType != onlyUnpaid) {
                $("[data-paid]").show();
            }
            else {
                $("[data-paid]").hide();
            }

            if (leaveType != onlyPaid) {
                $("[data-unpaid]").show();
            }
            else {
                $("[data-unpaid]").hide();
            }
        });
        $("[data-parentalleavetype]").trigger("change");
    }
}(window.parentalleave = window.parentalleave || {}, $));
